document.addEventListener('change', function (event) {
  const select = event.target.closest('variant-selects select');
  if (!select) return;

  const variantId = select.value;
  const productHandle = window.location.pathname.split('/products/')[1];

  fetch(`/products/${productHandle}.js`)
    .then(res => res.json())
    .then(product => {
      const variant = product.variants.find(v => v.id == variantId);
      const etaBox = document.getElementById('variant-eta');

      if (!variant || !etaBox) return;

      const label = variant.metafields?.custom?.eta_label;

      if (label) {
        etaBox.innerHTML = `<strong>Delivery:</strong> <span>${label}</span>`;
        etaBox.style.display = 'block';
      } else {
        etaBox.style.display = 'none';
      }
    });
});
